/**
 * 撮合成交模态框: 流拍车辆的撮合成交
 * props: visible             [boolean]     是否展示模态框
 *        dealPrice           [number]      默认成交价
 *        commission          [number]      佣金
 *        onOk                [function]    撮合成交成功后的回调
 *        onCancel            [function]    取消撮合成交
 *        sellerCode          [string|number]      卖家编号
 *        goodsId             [string|number]      拍品编号
 *  @arguments 撮合成交的接口在该模态框里请求，等后端出来接口之后，可能加参数props；
 */
import React, { Component } from 'react';
import { dispatch } from '@@/store';
import { SearchDealers } from '@/components';
import { Modal, Form, Input, InputNumber } from 'antd';
import { CHECK_Money7 } from '@/shared/reqexp';
import { toNumberOrEmpty } from '@/shared/functions';
class BrokeredDealTemp extends Component {
    constructor() {
        super(...arguments);
        this.handleOk = () => {
            dispatch.brokeredDeal.handleOk(this.props);
        };
        this.handleCancel = () => {
            dispatch.brokeredDeal.handleCancel(this.props);
        };
        this.handleSearch = (e) => {
            const { values } = e;
            dispatch.brokeredDeal.SET_STATE({ choosedDealers: values[0] });
        };
        this.onChange = (n, v) => {
            dispatch.brokeredDeal.onChange({ n, v, props: this.props });
        };
    }
    render() {
        const { visible, form, dealPrice, commission, servicePrice } = this.props;
        // 计算初始值
        const _d = Number(dealPrice) || 0;
        const _c = Number(commission) || 0;
        const _s = Number(servicePrice) || 0;
        const { getFieldDecorator } = form;
        const handPrice = _d * 1 + _s + _c;
        return (<Modal title="撮合成交" visible={visible} okText="确定" onOk={this.handleOk} cancelText="取消" onCancel={this.handleCancel}>
        <SearchDealers maxChoose={1} onChange={this.handleSearch}/>
        <Form style={{ marginTop: '20px' }} labelCol={{ span: 5 }} wrapperCol={{ span: 12 }}>
          <Form.Item label="成交价(元)">
            {getFieldDecorator('dealPrice', {
            rules: [
                { required: true, message: '请输入成交价' },
                { pattern: CHECK_Money7, message: '请输入不超过七位数的整百数，可为0' },
            ],
            initialValue: toNumberOrEmpty(dealPrice),
        })(<Input onChange={(e) => this.onChange('dealPrice', e.target.value)} placeholder="请输入100的整数倍，可为0"/>)}
          </Form.Item>
          <Form.Item label="服务费(元)">
            {getFieldDecorator('servicePrice', {
            rules: [
                { required: true, message: '请输入服务费' },
                { pattern: CHECK_Money7, message: '请输入不超过七位数的整百数，可为0' },
            ],
            initialValue: toNumberOrEmpty(servicePrice),
        })(<InputNumber min={0} step={100} onChange={(e) => this.onChange('servicePrice', e)} style={{ width: '100%' }} placeholder="请输入100的整数倍，可为0"/>)}
          </Form.Item>
          <Form.Item label="交易佣金">
            {getFieldDecorator('commission', {
            rules: [
                { required: true, message: '请输入交易佣金' },
                { pattern: CHECK_Money7, message: '请输入不超过七位数的整百数，可为0' },
            ],
            initialValue: toNumberOrEmpty(commission),
        })(<InputNumber min={0} step={100} onChange={(e) => this.onChange('commission', e)} style={{ width: '100%' }} placeholder="请输入100的整数倍，可为0"/>)}
          </Form.Item>
          <Form.Item label="合手价(元)">
            {getFieldDecorator('handPrice', { initialValue: handPrice || 0 })(<Input disabled/>)}
          </Form.Item>
        </Form>
      </Modal>);
    }
}
const BrokeredDeal = Form.create()(BrokeredDealTemp);
export default BrokeredDeal;
